module.exports = __webpack_public_path__ + "static/media/covid.c724d1af.jpg";